import * as actions from '../../store/actions'
import {store} from '../../store'


export const logout = (history) => {

    return new Promise(resolve => {
        store.dispatch(actions.user.setToken(''));
        store.dispatch(actions.user.updateTokenData({}));
        store.dispatch(actions.formFlow.clearFormFlow());
        store.dispatch(actions.infoFeed.clearInfoFeedDisplay());
        store.dispatch(actions.projectLeads.setProjects([]));
        store.dispatch(actions.projectLeads.setFocusedProject(null));
        store.dispatch(actions.session.clearVars());
        resolve();
    })
}


export const isUserLoggedIn = () => {
    const state = store.getState();

    if (!state.user.token || !state.user.token.length) return false;
    if (state.user.decodedTokenData.exp < new Date().getTime() / 1000) return false;

    return true;
}
